import { render, staticRenderFns } from "./WaybillTransitionHistoryModal.vue?vue&type=template&id=fad35510&scoped=true&"
import script from "./WaybillTransitionHistoryModal.vue?vue&type=script&lang=js&"
export * from "./WaybillTransitionHistoryModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fad35510",
  null
  
)

export default component.exports